import { Link } from 'react-router-dom';

interface RedirectCountdownProps {
  /** Libellé du bouton principal (destination finale). */
  targetLabel: string;
  targetPath: string;
  /** Second parcours proposé (commerçant / client). */
  altLabel: string;
  altPath: string;
  /** Décompte restant, en secondes. 0 = redirection annulée. */
  seconds: number;
  onCancel: () => void;
}

export default function RedirectCountdown({
  targetLabel,
  targetPath,
  altLabel,
  altPath,
  seconds,
  onCancel,
}: RedirectCountdownProps) {
  const total = 12;
  const progress = seconds > 0 ? Math.max(0, Math.min(100, Math.round(((total - seconds) / total) * 100))) : 100;

  return (
    <div className="w-full">
      <Link
        to={targetPath}
        className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-bold no-underline hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        {targetLabel}
        <i className="ri-arrow-right-line"></i>
      </Link>

      <div className="mt-3">
        {seconds > 0 ? (
          <>
            <div className="h-1 w-full rounded-full bg-background-200/70 overflow-hidden">
              <div
                className="h-full bg-accent-500 transition-all duration-1000 ease-linear"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <p className="mt-2 text-[11px] text-foreground-500">
              Redirection automatique dans <strong className="text-foreground-800">{seconds}s</strong>
              <button
                type="button"
                onClick={onCancel}
                className="ml-2 underline underline-offset-2 hover:text-foreground-800 cursor-pointer"
              >
                Annuler
              </button>
            </p>
          </>
        ) : (
          <p className="text-[11px] text-foreground-400">Redirection automatique désactivée.</p>
        )}
      </div>

      <Link
        to={altPath}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium no-underline hover:bg-background-200/70 transition-colors whitespace-nowrap"
      >
        <i className="ri-arrow-go-back-line"></i>
        {altLabel}
      </Link>
    </div>
  );
}